import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SessionService } from './session.service';
import { ENV } from '../config/environment';

@Injectable({ providedIn: 'root' })
export class IdleTimeoutService {
  private activityEventsSub: Subscription | null = null;
  private idleTimerSub: Subscription | null = null;
  private idleTimeoutMs: number;
  private lastActivityTs = Date.now();

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private sessionService: SessionService
  ) {
    const defaultMinutes = 30; // fallback if not configured
    const configured = Number((ENV as any)?.idleTimeoutMinutes);
    this.idleTimeoutMs = (Number.isFinite(configured) && configured > 0 ? configured : defaultMinutes) * 60 * 1000;
  }

  startWatching(): void {
    if (this.activityEventsSub) return;

    this.ngZone.runOutsideAngular(() => {
      const activity$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'click'),
        fromEvent(document, 'touchstart'),
        fromEvent(document, 'scroll')
      ).pipe(debounceTime(250));

      this.activityEventsSub = activity$.subscribe(() => this.resetIdleTimer());
      this.resetIdleTimer();
    });
  }

  stopWatching(): void {
    if (this.activityEventsSub) {
      this.activityEventsSub.unsubscribe();
      this.activityEventsSub = null;
    }
    if (this.idleTimerSub) {
      this.idleTimerSub.unsubscribe();
      this.idleTimerSub = null;
    }
  }

  private resetIdleTimer(): void {
    this.lastActivityTs = Date.now();
    if (this.idleTimerSub) {
      this.idleTimerSub.unsubscribe();
      this.idleTimerSub = null;
    }
    this.idleTimerSub = timer(this.idleTimeoutMs).subscribe(() => this.onIdle());
  }

  private onIdle(): void {
    this.stopWatching();
    // Clear session and navigate to login with reason
    this.sessionService.clear();
    this.ngZone.run(() => this.router.navigate(['/login'], { queryParams: { reason: 'idle' } }));
  }
}


